var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.element.component === 'movie')?_c('Movie',{attrs:{"movieId":_vm.element.id,"videoId":_vm.element.main_video_id,"_movie":_vm.element}}):(_vm.element.component === 'picture')?_c('Picture',{attrs:{"picture":_vm.element}}):_c('div',[_vm._v("\n    "+_vm._s(_vm.$t('video_watch.not_available'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }